import { $authHost } from ".."

export const addWriteOffActItemAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/`, dataForBd)
    return data
}

export const editWriteOffActItemAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}`, dataForBd)
    return data
}

export const editWriteOffActItemNameInActAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/name_in_act`, dataForBd)
    return data
}

export const editWriteOffActItemNomenclatureNumberAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/nomenclature_number`, dataForBd)
    return data
}

export const editWriteOffActItemInventoryNumberAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/inventory_number`, dataForBd)
    return data
}

export const editWriteOffctItemDateReceiptAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/date_receipt`, dataForBd)
    return data
}

export const editWriteOffctItemServiceLifeAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/service_life`, dataForBd)
    return data
}

export const editWriteOffctItemPassportNumberAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/passport_number`, dataForBd)
    return data
}

export const editWriteOffActItemPriceAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/${dataForBd.id}/price`, dataForBd)
    return data
}

export const agreeWriteOffActItemDirectorAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/agree_items_director/${dataForBd.id}`, dataForBd)
    return data
}

export const agreeWriteOffActItemAccountantAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/write_off_act_items/agree_items_accountant/${dataForBd.id}`, dataForBd)
    return data
}